// @ts-nocheck
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { ParametersOmitFirst, ParametersTakeFirst } from "@toolkit/Framework/Types/Common";
import { useSelector } from "react-redux";

const convertSelectorToHooks = <T extends (state: ApplicationState, ...args: any[]) => any>(fn: T) => {
    return (...args: ParametersOmitFirst<T>): ReturnType<T> => {
        return useSelector((state: ParametersTakeFirst<T>) => fn(state, ...args));
    };
};

export default convertSelectorToHooks;
